import React from 'react';
import { Logo } from '@/components/Logo';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-12 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8 rounded-2xl bg-white p-8 shadow-sm border border-gray-100">
        <div className="flex flex-col items-center">
          <Logo className="h-12 w-auto mb-6"/>
          {children}
        </div>
      </div>
    </div>
  );
};
